import { motion } from "framer-motion";
import heroImage from "../../assets/images/hero-image-12.jpg";
import client1 from "../../assets/images/gallery/clients/client1.png";
import client2 from "../../assets/images/gallery/clients/client2.png";
import client3 from "../../assets/images/gallery/clients/client3.png";
import client4 from "../../assets/images/gallery/clients/client4.png";

export default function ReviewsSection() {
  return (
    <section
      id="reviews"
      className="relative py-32 overflow-hidden"
      style={{
        backgroundImage: `url(${heroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* DARK OVERLAY  BACKGROUND ONLY */}
      <div className="absolute inset-0 bg-[#0e202b]/90 z-0" />

      {/* ================= CONTENT ================= */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 space-y-20">

        {/* ================= HEADING ================= */}
        <div className="max-w-3xl space-y-6">
          <div className="inline-flex items-center gap-2 bg-white/10 px-6 py-2 rounded-full text-sm text-white w-fit">
            Voices From The Mountains
          </div>

          <h2 className="text-[3.5rem] font-bold leading-tight text-white">
            Experiences shared.
          </h2>

          <p className="text-lg text-gray-300 max-w-xl">
            Words from trekkers and explorers who’ve journeyed with us across
            remote landscapes and demanding terrain.
          </p>
        </div>

        {/* ================= GRID ================= */}
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 items-stretch">

          {/* ===== LEFT SUMMARY CARD ===== */}
          <div className="bg-[#091720] backdrop-blur rounded-[24px] p-8 text-white shadow-xl flex flex-col justify-between h-full">

            <div className="space-y-6">
              <h3 className="text-3xl font-bold">Trusted by Explorers</h3>
              <p className="text-gray-300 max-w-sm">
                Rated by adventurers who trusted BroadBoy with once-in-a-lifetime
                mountain journeys.
              </p>
            </div>

            {/* Avatars */}
            <div className="flex items-center mt-10">
              {[
                client1,
                client2,
                client3,
                client4,
              ].map((img, i) => (
                <div
                  key={i}
                  className="-ml-3 first:ml-0 w-12 h-12 rounded-full border-2 border-white overflow-hidden shadow-lg"
                >
                  <img
                    src={img}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
              ))}
            </div>

            {/* Stars */}
            <div className="mt-6 space-y-2">
              <div className="flex gap-1 text-yellow-400 text-lg">
                {"★★★★★"}
              </div>
              <p className="text-sm text-gray-400">
                Trusted by climbers & trekkers worldwide
              </p>
              <p className="text-sm text-gray-500">
                The mountains test you  we prepare you.
              </p>
            </div>

            {/* CTA */}
            <a
              href="/contact"
              className="mt-8 inline-flex justify-center items-center bg-gray-400/20 text-white py-4 rounded-full font-medium shadow-lg hover:bg-white transition"
            >
              Share your experience
            </a>
          </div>

          {/* ===== RIGHT REVIEWS ===== */}
          <div className="grid sm:grid-cols-2 gap-6">

            <ReviewCard
              rating="4.9"
              text="Everything was handled professionally  from preparation to execution. The route planning gave us complete confidence."
              name="Leena Adams"
              role="K2 Base Camp Trekker"
              img={client1}
            />

            <ReviewCard
              rating="5.0"
              text="The experience felt raw and authentic. BroadBoy respected the mountains and the people moving through them."
              name="Anam Uzair"
              role="High-Alt Mountaineer"
              img={client2}
            />

            <ReviewCard
              rating="4.9"
              text="Clear guidance, solid logistics, and an unforgettable journey. I’d do it again without hesitation."
              name="Fariha Sheikh"
              role="Adventure Traveler"
              img={client3}
            />

            <ReviewCard
              rating="4.9"
              text="This wasn’t just a trip  it was a well-crafted expedition. Everything felt intentional."
              name="Asha Noor Shehryar"
              role="Mountain Explorer"
              img={client4}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

/* ================= REVIEW CARD ================= */

function ReviewCard({ rating, text, name, role, img }) {
  return (
    <div className="bg-white/10 backdrop-blur rounded-[20px] p-5 shadow-[rgba(0,0,0,0.25)_0px_10px_30px] flex flex-col justify-between">

      <div className="bg-gray-500/30 rounded-[16px] p-5 space-y-4">
        <div className="flex items-center gap-2 text-sm font-medium">
          <span>{rating}</span>
          <span className="text-yellow-400">★★★★★</span>
          <span className="text-gray-500">Rating</span>
        </div>

        <p className="font-semibold leading-snug text-white">
          {text}
        </p>
      </div>

      <div className="flex items-center gap-4 mt-5">
        <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white">
          <img
            src={img}
            alt={name}
            className="w-full h-full object-cover"
          />
        </div>

        <div>
          <p className="font-semibold text-white">{name}</p>
          <p className="text-sm text-gray-300">{role}</p>
        </div>
      </div>
    </div>
  );
}
